import { render, staticRenderFns } from "./GameSetting.vue?vue&type=template&id=25f77583&scoped=true"
import script from "./GameSetting.vue?vue&type=script&lang=js"
export * from "./GameSetting.vue?vue&type=script&lang=js"
import style0 from "./GameSetting.vue?vue&type=style&index=0&id=25f77583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f77583",
  null
  
)

export default component.exports